import NoticeContent from "./NoticeContent";
import NoticeTitle from "./NoticeTitle";

class Notice {
  constructor(private readonly _title: NoticeTitle = new NoticeTitle(), private readonly _content: NoticeContent = new NoticeContent()) {
  }

  get title() {
    return this._title;
  }

  get content() {
    return this._content;
  }
}

export default Notice;
